import { Image as FluentImage } from "@fluentui/web-components";
/**
 * Image
 * @summary A Fabric UI Image component that provides a customizable image element with layout, border, shadow, fit, and shape options.
 *
 * @example
 * ```html
 * <fabric-image block fit="cover" shape="rounded">
 *   <img src="path-to-image.jpg" alt="Descriptive text">
 * </fabric-image>
 * ```
 *
 * @attr {boolean} block - Image layout. Boolean attribute that, when present, applies a block layout to the image.
 * @attr {boolean} bordered - Image border. Boolean attribute that, when present, applies a border to the image.
 * @attr {boolean} shadow - Image shadow. Boolean attribute that, when present, applies a shadow effect to the image.
 * @attr {ImageFit} fit - Image fit, with options 'none', 'center', 'contain', 'cover'. Determines how the image should be resized to fit its container.
 * @attr {ImageShape} shape - Image shape, with options 'circular', 'rounded', 'square'. Determines the shape of the image.
 *
 * @prop {boolean} block - Image layout. Boolean property that, when set, applies a block layout to the image.
 * @prop {boolean} bordered - Image border. Boolean property that, when set, applies a border to the image.
 * @prop {boolean} shadow - Image shadow. Boolean property that, when set, applies a shadow effect to the image.
 * @prop {ImageFit} fit - Image fit, with options 'none', 'center', 'contain', 'cover'. Determines how the image should be resized to fit its container.
 * @prop {ImageShape} shape - Image shape, with options 'circular', 'rounded', 'square'. Determines the shape of the image.
 *
 * @slot - The default slot for the image content. Place an <img> element here to display the image.
 *
 * @extends FluentImage
 * @tagname fabric-image
 * @public
 */
export class Image extends FluentImage {
}
//# sourceMappingURL=image.js.map